import { useTranslation } from 'react-i18next'
import errorIcon from '../assets/images/contact/error.svg'
import Button from './Buttons/Button'


const Notfound = () => {
    const { t } = useTranslation()

    return (
        <div className="grid h-screen place-content-center bg-white">
            <div className="text-center">
                <img src={errorIcon} alt="error" className="w-64 mx-auto" />

                <h1 className="mt-6 text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl">Uh-oh!</h1>

                <div className='flex flex-col justify-center items-center'>
                    <p className="mt-4 text-2xl sm:text-4xl">{ t('notfound_title') }</p>
                    <p className="mt-4 text-gray-500 mb-6">{ t('notfound_description') }</p>
                    <Button call={ t('notfound_button') } link={'/contact'}/>
                </div>
            </div>
        </div>
    )
}

export default Notfound